import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { FormRdvComponent } from './form-rdv/form-rdv.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { routes } from './routes';
import { SidebarModule } from 'ng-sidebar';
import { TableModule } from 'primeng/table';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database-deprecated';
import { AngularFireAuthModule } from 'angularfire2/auth';
import {TabMenuModule} from 'primeng/tabmenu';
import { DataTableModule } from 'primeng/primeng'; // Here
import { PaginatorModule } from 'primeng/primeng'; // Here
import { DatePipe } from '@angular/common';
import {DialogModule} from 'primeng/dialog';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RadioButtonModule} from 'primeng/radiobutton';

export const firebaseConfig = {
  apiKey: "AIzaSyBkBRbf0Zih9Xu8BNWL1FoXmbQ2_ydC2Bc",
  authDomain: "flandresapp.firebaseapp.com",
  databaseURL: "https://flandresapp.firebaseio.com",
  projectId: "flandresapp",
  storageBucket: "flandresapp.appspot.com",
  messagingSenderId: "763592009167",
  appId: "1:763592009167:web:9426fbc23b013546f71eba"
};

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    FormRdvComponent,
    SidemenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TableModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    SidebarModule.forRoot(),
    RouterModule.forRoot(routes),
    TabMenuModule,
    PaginatorModule,
    DataTableModule,
    BrowserAnimationsModule,
    DialogModule,
    RadioButtonModule
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
